// extracted by mini-css-extract-plugin
export default {"root":"H1i7mlEN"};